'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('services.authenticatedUser', [])

.factory('authenticatedUserService', ['$http', function ($http) {
    var baseUrl = environment.apiUrl + '/Pilot/api/AuthenticatedUser';

    var service = {};

    service.getAuthenticatedUser = function () {
        return $http.get(baseUrl, { cache: true })
                    .then(function (response) {
                        return response.data;
                    });
    };

    return service;
}]);
